/**
 * 쪽 넘기기 — 계약 0-6 의 두 방식.
 *
 * - offset·limit(배열 답): 받은 줄 수가 limit 과 같으면 다음 쪽이 있다고 본다(명세 EA-06).
 * - page·size(`items`·`total`): total 로 다음·마지막을 안다.
 *
 * ⚠ 한 쪽뿐이면 그리지 않는다(레거시 Pager 그대로).
 */
import { Button } from './ui'

export function OffsetPager({ offset, limit, count, onChange }: {
  offset: number
  limit: number
  /** 이번에 받은 줄 수. 모르면(불러오는 중) undefined. */
  count: number | undefined
  onChange: (offset: number) => void
}) {
  const hasNext = count !== undefined && count >= limit
  const atStart = offset === 0
  if (!hasNext && atStart) return null
  return (
    <div className="mt-3 flex items-center gap-2">
      <Button tone="plain" onClick={() => onChange(0)} disabled={atStart}>First</Button>
      <Button tone="plain" onClick={() => onChange(offset + limit)} disabled={!hasNext}>Next</Button>
      {!hasNext && count !== undefined && <span className="text-xs text-slate-500">Last page</span>}
    </div>
  )
}

export function PagePager({ page, size, total, onChange, withPrev, always }: {
  page: number
  size: number
  /** 서버가 준 전체 수. 모르면 undefined. */
  total: number | undefined
  onChange: (page: number) => void
  /** 「이전」 단추를 둘지(거래 모니터·이상거래 큐 — 명세 EA-29·EA-41). */
  withPrev?: boolean
  /** 한 쪽뿐이어도 그린다(거래 모니터 — 레거시 그대로). */
  always?: boolean
}) {
  const hasNext = total !== undefined && (page + 1) * size < total
  const atStart = page === 0
  if (!hasNext && atStart && !always) return null
  return (
    <div className="mt-3 flex items-center gap-2">
      <Button tone="plain" onClick={() => onChange(0)} disabled={atStart}>First</Button>
      {withPrev && (
        <Button tone="plain" onClick={() => onChange(Math.max(0, page - 1))} disabled={atStart}>Previous</Button>
      )}
      <Button tone="plain" onClick={() => onChange(page + 1)} disabled={!hasNext}>Next</Button>
      {!hasNext && total !== undefined && <span className="text-xs text-slate-500">Last page</span>}
    </div>
  )
}
